// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ComponentOutlinedSvg from "@fishx/icons-svg/es/asn/ComponentOutlined";
import FishxIcon from '../components/FishxIcon';

var ComponentOutlined = function ComponentOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: ComponentOutlinedSvg
  }));
};

ComponentOutlined.displayName = 'ComponentOutlined';
export default React.forwardRef(ComponentOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/ComponentOutlined.js
// module id = 2304
// module chunks = 0